<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{ width: '680px' }"
  styleClass="p-fluid comunica-contributo-dialog"
  [showHeader]="false"
  (onHide)="hide()"
>
  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-euro header-icon"></i>
        <h2>Storico liquidazioni</h2>
        <div class="code-badge">
          <span class="code-value">{{ intervento?.scheda?.codice }}</span>
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()"
      ></button>
    </div>

    <div class="dialog-content">

      <div class="loading-container" *ngIf="isLoading">
        <ng-lottie class="loader-lottie" [options]="lottieConfig"></ng-lottie>
      </div>

      <div *ngIf="!isLoading">

        <div *ngIf="liquidazioni && liquidazioni.length > 0" class="liquidazioni-list">

          <!-- Totale riepilogativo -->
          <div class="totale-row">
            <span class="totale-label">
              <i class="pi pi-calculator"></i>
              Totale liquidato
            </span>
            <span class="totale-valore">
              &euro;&nbsp;{{ getTotaleLiquidato() | currency:'EUR':'':'1.2-2':'it-IT' }}
            </span>
          </div>

          <!-- Card per ogni liquidazione -->
          <div
            class="liquidazione-card"
            *ngFor="let liq of liquidazioni; let i = index"
          >
            <div class="card-left">
              <div class="card-index">{{ i + 1 }}</div>
              <div class="card-connector" *ngIf="i < liquidazioni.length - 1"></div>
            </div>

            <div class="card-body">
              <div class="card-row-main">
                <span class="importo-chip">
                  <i class="pi pi-euro importo-icon"></i>
                  {{ liq.importo | currency:'EUR':'':'1.2-2':'it-IT' }}
                </span>
                <span
                  *ngIf="liq.tipoRendicontazione?.descrizione"
                  class="tipo-rend-badge badge"
                  [ngClass]="getTipoRendicontazioneBadgeClasses(liq.tipoRendicontazione)"
                >
                  {{ liq.tipoRendicontazione?.descrizione }}
                </span>
                <span class="data-badge">
                  <i class="pi pi-calendar"></i>
                  {{ liq.dataLiquidazione | date:'dd/MM/yyyy' }}
                </span>
              </div>

              <div class="note-row" *ngIf="liq.note">
                <i class="pi pi-comment note-icon"></i>
                <span class="note-text">{{ liq.note }}</span>
              </div>
            </div>
          </div>

        </div>

        <div *ngIf="!liquidazioni || liquidazioni.length === 0" class="empty-state">
          <i class="pi pi-inbox empty-icon"></i>
          <p>Nessuna liquidazione registrata per questo intervento.</p>
        </div>

      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()"
      ></button>
    </div>
  </div>
</p-dialog>
